import { defineStore } from 'pinia';
import { api } from '@/lib/api';

/**
 * Broadcasts the signed-in user's presence by pinging the server on a timer. The
 * server derives online/offline from the freshness of this ping, so a backgrounded
 * or closed tab lapses to offline on its own. App starts it on authentication and
 * stops it on sign-out; it pauses while the tab is hidden.
 */
const PING_MS = 45_000;

export const usePresenceStore = defineStore('presence', () => {
  let timer: number | null = null;

  async function ping(): Promise<void> {
    try {
      await api.post('/presence/heartbeat', {});
    } catch {
      // A missed ping just means we look offline a little sooner; the next one recovers.
    }
  }

  function start(): void {
    if (timer != null) return;
    void ping();
    timer = window.setInterval(() => {
      if (!document.hidden) void ping();
    }, PING_MS);
  }

  function stop(): void {
    if (timer != null) {
      clearInterval(timer);
      timer = null;
    }
  }

  return { ping, start, stop };
});
